import { displayMessage } from "../services/helper";

 const EDaysOfTheWeek = {
  get MONDAY() {
    return { code: 1, label: displayMessage("MONDAY") };
  },
  get TUESDAY() {
    return { code: 2, label: displayMessage("TUESDAY") };
  },
  get WEDNESDAY() {
    return { code: 3, label: displayMessage("WEDNESDAY") };
  },
  get THURSDAY() {
    return { code: 4, label: displayMessage("THURSDAY") };
  },
  get FRIDAY() {
    return { code: 5, label: displayMessage("FRIDAY") };
  },
  get SATURDAY() {
    return { code: 6, label: displayMessage("SATURDAY") };
  },
  get SUNDAY() {
    return { code: 7, label: displayMessage("SUNDAY") };
  }
};


export default EDaysOfTheWeek